import { CustomKeyAttributes } from '@loyalty/shared-common/profile-api-client';
import { Fields } from '@react-awesome-query-builder/core';
import { BaseConfigSettings } from '../fields';
import { profileFields } from './profile-fields';
import { shouldBeApositiveNumber } from './should-be-apositive-number';

export function qualifioLoyaltyMemberVisit(
  settings: BaseConfigSettings,
  customKeys?: CustomKeyAttributes[],
): Fields {
  const { t } = settings;
  return {
    event: {
      label: t('rule.criteria.event'),
      type: '!group',
      subfields: {
        previousVisit: {
          label: t('rule.criteria.visit.previous'),
          type: 'datetime',
          preferWidgets: ['datetime'],
        },
        consecutiveDailyVisits: {
          label: t('rule.criteria.visit.consecutive.visits'),
          type: 'number',
          fieldSettings: {
            validateValue: shouldBeApositiveNumber,
          },
          valueSources: ['value'],
        },
        totalDailyVisits: {
          label: t('rule.criteria.visit.total'),
          type: 'number',
          fieldSettings: {
            validateValue: shouldBeApositiveNumber,
          },
          valueSources: ['value'],
        },
        timestamp: {
          label: t('rule.criteria.date'),
          type: 'datetime',
          preferWidgets: ['datetime'],
        },
      },
    },
    profile: {
      label: t('rule.criteria.profile'),
      type: '!group',
      subfields: profileFields(settings, customKeys),
    },
  };
}
